import http from "./httpService";

const endPoint = "/api/v1/Products";


export async function addProduct(request) {
    return await http.post(endPoint, request);
}

export async function getAllProducts(category) {
    return await http.get(`${endPoint}/All`, {
        params: {
            categoryId: category
        }
    });
}

export function getProducts(category) {
    return http.get(`${endPoint}`, { params: { categoryId: category } });
}

export function updateProduct(id, request) {
    return http.put(`${endPoint}/${id}`, request);
}

export function updateProductImage(id, request) {
    return http.put(`${endPoint}/${id}/Image`, request );
}


export default { addProduct, getAllProducts, getProducts, updateProduct, updateProductImage };


// WEBPACK FOOTER //
// ./src/services/ProductsService.js